import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface LeaveSummary {
  count: number;
  percentage: number;
}

export interface MonthlyLeavesSummaryData {
  totalLeaves: LeaveSummary;
  approvedLeaves: LeaveSummary;
  pendingRequests: LeaveSummary;
  rejectedLeaves: LeaveSummary;
}

export interface MonthlyLeavesSummaryResponse {
  success: boolean;
  data: MonthlyLeavesSummaryData;
}

const fetchMonthlyLeavesSummary = async (
  month: number,
  year: number
): Promise<MonthlyLeavesSummaryResponse> =>
  (
    await customAxios.get<MonthlyLeavesSummaryResponse>(
      `/reports/leaves/monthlySummary?month=${month}&year=${year}`
    )
  ).data;

export const useGetMonthlyLeavesSummary = (month: number, year: number) =>
  useQuery<MonthlyLeavesSummaryResponse, AxiosError>(
    ["monthlyLeavesSummary", month, year],
    () => fetchMonthlyLeavesSummary(month, year),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Monthly Summary",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load monthly leave summary.",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
